import { createContext, useContext } from 'react';

// Column context interface
export interface ColumnContextValue {
  columnId: string;
  getTaskIndex: (taskId: string) => number;
  getNumTasks: () => number;
}

// Create the context with a fallback
export const ColumnContext = createContext<ColumnContextValue | null>(null);

// Custom hook for using column context
export function useColumnContext(): ColumnContextValue {
  const context = useContext(ColumnContext);
  
  if (!context) {
    throw new Error('useColumnContext must be used within a ColumnContext.Provider');
  }
  
  return context;
}